import React, { useEffect, useState } from 'react';
import './App.scss';
import { Content, Header, InfoMessage } from './components';
import { LoginModal } from './modals';
import { Stats, Websystem, History, Admin, Overview } from './pages';
import { useAction, useAppState } from './hooks';
import { AUTH_COOKIE } from './utils';
import { EPage, TUser } from './types';
import { getUserWithoutDetail } from './api';
import Cookies from 'js-cookie'

function App() {
    const {setTokenAction } = useAction()
    const [loginModalVisible, setLoginModalVisible] = useState(false)
    const { state } = useAppState()
    const [user, setUser] = useState<TUser | undefined>(undefined)
    const handleLoginModalOpen = () => setLoginModalVisible(true);
    const handleLoginModalClose = () => setLoginModalVisible(false);
    const [page, setPage] = useState(EPage.WEBYSTEM)
    const [inputCode, setInputCode] = useState('')
    const [startCode, setStartCode] = useState('')

    useEffect(() => {
        if (!user) {
            setLoginModalVisible(true)
        }
        const queryParameters = new URLSearchParams(window.location.search)
        console.log(queryParameters)
        if (queryParameters) {
            let loginToken = queryParameters.get("loginToken")
            if (loginToken) {
                setTokenAction(loginToken)
                Cookies.set(AUTH_COOKIE, loginToken, { expires: 7 })
                localStorage.setItem('authToken', loginToken);
                return
            }
            let inputCode = queryParameters.get("cypher")
            if (inputCode) {
                setInputCode(inputCode)
            }
            let startCode = queryParameters.get("start")
            if (startCode) {
                setStartCode(startCode)
            }
        }
        if (!state?.token) {
            const cookie = Cookies.get(AUTH_COOKIE)
            if (cookie) {
                setTokenAction(cookie)
            } else {
                const token = localStorage.getItem('authToken');
                if (token) {
                    setTokenAction(token)
                }
            }
        }
    }, [])

    useEffect(() => {
        if (state?.token) {
            getUserWithoutDetail({ token: state.token }).then((response) => {
                if (response.user) {
                    setUser(response.user)
                    setLoginModalVisible(false)
                }
            })
        } else {
            setUser(undefined)
        }
    }, [state?.token])


    const getPage = () => {
        if (loginModalVisible) return <></>
        switch (page) {
            case EPage.WEBYSTEM:
                return <Websystem inputCode={inputCode} setInputCode={setInputCode} startCode={startCode} setStartCode={setStartCode} setLoginModalVisible={setLoginModalVisible } />
            case EPage.STATS:
                return <Stats />
            case EPage.HISTORY:
                return <History />
            case EPage.ADMIN:
                return <Admin />
            case EPage.OVERVIEW:
                return <Overview />
            default: return <></>
        }
    }

    return (
        <div className="App">
            <Header handleLoginModalOpen={handleLoginModalOpen} setPage={setPage} page={page } />
            <LoginModal open={loginModalVisible} handleClose={handleLoginModalClose} user={user } />
            <InfoMessage />
            <Content page={page }>
                <>
                    {getPage()}
                </>
            </Content>
        </div>
    );
}

export default App;
